import React from "react";
import moment from "moment";
import "moment/locale/fr";

const BookingCard = ({
  date,
  startTime,
  service,
  duration,
  soin,
}) => {
  return (
    <div
      className="service-card card shadow-sm mx-auto"
      style={{
        minHeight: "100px",
      }}
    >
      <div className="card-body">
        <p>Date du rendez-vous : {moment(date).format("DD/MM/YYYY")} </p>
        <p>Heure du rendez-vous : {startTime} </p>
        <p>Service : {service}</p>
        <p>Soin : {soin}</p>
        <p>Durée : {duration} minutes</p>
      </div>
    </div>
  );
};

export default BookingCard;
